/** @format */

import React from "react";
import "./ResourcePage.scss";
import { useGetResourceReferenceQuery } from "../../../app/services/resourcesApi";
import { Navigate, useParams } from "react-router-dom";
import { useLocale } from "../../../i18n/hooks";
import { skipToken } from "@reduxjs/toolkit/query";
import ResourcePageUI from "./ResourcePageUI";
import { useTranslation } from "react-i18next";
import { useGetSubjectsQuery } from "../../../app/services/subjectApi";
import { QualificationId } from "../../../types";
import BreadCrumb from "../../breadcrumb/BreadCrumb";
import { subjectNameToId } from "../../../utils/functions";

const ResourcePage: React.FC = () => {
  const { data: subjectsResponse } =
    useGetSubjectsQuery();
  const { resourceId, qualification, type, subject } = useParams();
  const locale = useLocale();
  const { t: _ } = useTranslation();

  const {
    data: resource,
    error: resourceError,
    isFetching,
  } = useGetResourceReferenceQuery(
    resourceId && type && subject && qualification && subjectsResponse
      ? {
          code: resourceId,
          locale,
          type: type,
          subjectId: subjectNameToId(subject, subjectsResponse.subjects),
          qualification: qualification as QualificationId,
        }
      : skipToken,
  );

  return (
    <>
      {resourceError && <Navigate to="/404" />}

      {isFetching || !resource ? (
        <div className="alert alert-info">{_("Loading")}...</div>
      ) : (
        <>
          <BreadCrumb resource={resource} />
          <ResourcePageUI resourceRef={resource} />
        </>
      )}
    </>
  );
};

export default ResourcePage;
